import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  linkPattern: belongsTo('link-pattern', { inverse: null }),
  shortUrl: belongsTo('short-url', { inverse: 'targets' }),
});
